import React, { useMemo } from 'react';

import { CustomFilterPopover } from '@vlabs/shared/components/filters-panel/components/CustomFilterPopover';
import { Divider } from '@vlabs/uikit';
import { Radio } from '@vlabs/uikit/components/controls/radio';
import imageSampleBody from '@vlapps/point/src/images/Select-Image-Body.png';
import imageSampleFace from '@vlapps/point/src/images/Select-Image-Face.png';
import { useTranslation } from 'react-i18next';

import st from './EventSampleSettingsPopover.module.sass';
import { useEventInfoSettingsLocation } from '../../useEventInfoSettingsSearchParams';
import type { MainSample, SampleType } from '../../useEventInfoSettingsSearchParams';
import { SelectImage } from './select-image/SelectImage';

export function EventSampleSettingsPopover(): React.JSX.Element {
  const { t } = useTranslation();
  const { eventInfoSettings: { sampleType, mainSample }, setEventInfoSetting } = useEventInfoSettingsLocation();

  const selectImageOptions = useMemo(() => [
    { id: 'face', imageUrl: imageSampleFace, alt: t('lunapoint:settings.select_image.alt.face') },
    { id: 'body', imageUrl: imageSampleBody, alt: t('lunapoint:settings.select_image.alt.body') },
  ], [t]);

  const changeSampleType = (value: SampleType) => () => {
    setEventInfoSetting('sampleType', value);
  };

  const changeMainSample = (value: MainSample) => {
    setEventInfoSetting('mainSample', value);
  };

  return (
    <CustomFilterPopover
      placementProp="right-start"
      testId="eventSampleSettings"
      triggerValue={t('lunapoint:settings.face_body_display_settings')}
    >
      <label className="Subtitle-2">
        {t('lunapoint:settings.show_in_events')}
      </label>
      <Divider small />

      <Radio
        checked={sampleType === 'multi'}
        id="multi"
        label={t('lunapoint:settings.sample_type.multi')}
        onChange={changeSampleType('multi')}
      />
      <Divider small />

      <Radio
        checked={sampleType === 'face'}
        id="face"
        label={t('lunapoint:settings.sample_type.face')}
        onChange={changeSampleType('face')}

      />
      <Divider small />

      <Radio
        checked={sampleType === 'body'}
        id="body"
        label={t('lunapoint:settings.sample_type.body')}
        onChange={changeSampleType('body')}
      />
      <Divider small />

      <div className={st.Divider} />
      <Divider small />

      <label className="Subtitle-2">
        {t('lunapoint:settings.default_display_order')}
      </label>
      <Divider small />

      <SelectImage
        disabled={sampleType !== 'multi'}
        onChange={changeMainSample}
        options={selectImageOptions}
        value={mainSample}
      />
    </CustomFilterPopover>
  );
}
